import React from 'react'

import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectIsRequestingBrandedContentAd } from '@store/submissions'
import Theme from '@theme'
import { Button, Header } from '@tribegroup'

const ButtonRequestPricing: React.FC = () => {
  const { watch } = useFormContext()
  const isRequesting = useSelector((state: IApplicationState) =>
    selectIsRequestingBrandedContentAd(state),
  )

  const watchSpendAmount = watch('planned_spend_amount', 0)

  const disabled = !watchSpendAmount || parseInt(watchSpendAmount) <= 0 || isRequesting

  return (
    <Button
      scheme="primary"
      fullWidth
      disabled={disabled}
      loading={isRequesting}
      data-testid="request-pricing-button"
    >
      <Header color={disabled ? Theme.grey700Color : Theme.whiteColor} uppercase cta>
        <FormattedMessage id="core.text.requestPricing" />
      </Header>
    </Button>
  )
}

export { ButtonRequestPricing }
export default ButtonRequestPricing
